// React
import React, { Component } from 'react';

// Redux
import { connect } from 'react-redux';
import * as actions from '../../actions';

// Components
import { Hero } from '../../components/Hero';
import { FluidSection } from '../../components/FluidSection';
import { Content } from '../../components/Content';
import { List } from '../../components/List';
import { StretchCard } from '../../components/StretchCard';
import { StretchVideo } from '../../components/StretchVideo';
import { VideoModal } from '../../components/VideoModal';

import { Calendar } from '../../components/Calendar';
import FlatButton from 'material-ui/FlatButton';
// import { Button } from '../../components/Button';
import ArrowLeft from 'material-ui/svg-icons/hardware/keyboard-arrow-left';
// import { LogoAvatar } from '../../components/LogoAvatar';

// Others
import { constants } from '../../constants';
// import { expertDetailStyles } from './styles';

import SwipeableViews from 'react-swipeable-views';

class ExpertDetailPage extends Component {

    constructor () {
        super();
        this.state = {
            buttonVisible: true,
            calendarFlexStyle: {},
            company: null,
            height: 0,
            heroHeight: '450px',
            heroOrientation: 'row',
            mainHeroButtonIcon: '',
            mainHeroButtonText: 'Book Your Consultation',
            provider: null,
            randomCards: null,
            service: null,
            showCalendar: false,
            showModal: false,
            viewIndex: 0,
            width: 0,
        };

        this.handleOpenVideoModal = this.handleOpenVideoModal.bind(this);
    }
    
    // ########## LIFE CYCLE HOOKS ############## //
    
    componentWillMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions, this.handleHeroMobileChanges);
        // this.props.getDBProviders();
        // this.setState(this.getNRandomNumbers(0, props.experts.length-1, 3)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions, this.handleHeroMobileChanges);
    }

    componentDidUpdate(nextState){
        if (this.state.width !== nextState.width){
            if ( this.state.width < 800 && (this.state.heroOrientation !== 'column')) {
                this.setState({
                    heroOrientation: 'column'
                });
                
            }else if ( this.state.width >= 800 && (this.state.heroOrientation !== 'row')) {
                this.setState({
                    heroOrientation: 'row'
                });
            }
        }
    }
    
    componentDidMount(){
            // Recive window dimetions
            this.updateWindowDimensions();
            window.addEventListener('resize', this.updateWindowDimensions, this.handleHeroMobileChanges);
            // AIUTOFOCUS THE SEARCH
            // Go to the top of the page on load
            document.getElementById('top').scrollIntoView();
            // window.scrollTo(0, 0);
            // this.top.scrollTop = this.top.scrollHeight;
            this.props.getDBProviders();
            this.props.getDBServices();
            this.props.getDBProviderCompanies();
            this.props.getDBServiceCategories();
            this.props.getDBServiceModules();
        }
        
        componentWillReceiveProps(nextProps) {
            if (nextProps.providers && nextProps.services && nextProps.companies) {
                this.getProviderAndCompany(nextProps);
            }
        }

    // ########################################### //


    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    getProviderAndCompany = (props) => {
        // console.log(`%c${JSON.stringify(props.companies)}`,'color: aqua');
        return props.providers.map((provider)=> {
            // console.log(`%c${JSON.stringify(provider.uid)} ${JSON.stringify(props.match.params.id)}`,'color: deeppink');
            
            if (provider.uid === props.match.params.id) {
                return props.companies.map(company => {
                    if (company._id === provider.providerCompany) {
                        this.setState({
                            company,
                            provider,
                        }, ()=>{
                            // const { SBMId, sbmVideoServiceId } = this.state.provider;
                            // props.getCalendar(provider.SBMId, service.SBMId);
                        })
                        
                        return;
                    }
                })
            }
            
        });
    }

    getProviderServices = (provider, company, providerFullName) => {
        const providerServices = this.props.services.map(service => {
            if (service.provider === provider.uid) {
                return (
                    <StretchCard
                        key={service._id}
                        cardImageHeight={275}
                        linkURL={`/service/detail/${service._id}`}
                        backgroundImageURL={service.coverPhotoURL}
                        avatarURL={provider.profilePhotoURL}
                        logoURL={company.logoURL}
                        typeTitleText={provider.expertise}
                        mainTitleText={service.name}
                        serviceTitleText={`${service.name} | $${service.price}`}
                        subTitleText={`${providerFullName} | ${provider.expertise}`}
                        firstIcon="heart"
                        secondIcon="s15"                                                            
                    />
                );
            }
        })
        return providerServices.filter(service => service);
    }

    // getNRandomNumbers = (min, max, n) => {
    //     let arr = [];
    //     while(arr.length < (n + 1)){
    //         const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min
    //         if(arr.indexOf(randomNumber) > -1) continue;
    //         arr[arr.length] = randomNumber;
    //         console.log(arr);
    //     }
    //     return arr;
    // }

    handleOpenVideoModal = () => {
        this.setState({ showModal: true });
    }

    handleCloseVideoModal = () => {
        this.setState({ showModal: false });
        // console.log('CLOSE VIDEO HAS RUN');
    }

    getDateToday = () => {
        let today = new Date();
        let dd = today.getDate();
        let mm = today.getMonth()+1; //January is 0!

        const yyyy = today.getFullYear();
        if(dd<10){
            dd='0'+dd;
        }
        if(mm<10){
            mm='0'+mm;
        }
        const date = mm+'-'+dd+'-'+yyyy;

        return date;
    }
    
    handleHeroMobileChanges = () => {
        // console.log( 'HHMC')
        if ( this.state.width < 800 ) {
            this.setState({
                heroOrientation: 'column'
            });
        }
    }

    handleChangeViewIndex = (index) => {
        if (index === 1) {
            this.setState({
                heroHeight: 450,
                heroOrientation: 'row',
                mainHeroButtonIcon: null,
                mainHeroButtonText: null,
                showCalendar: true,
                viewIndex: index,
            });
        } else {
            this.setState({
                showCalendar: false,
                heroHeight: 450,
                heroOrientation: 'column',
                mainHeroButtonIcon: null,
                mainHeroButtonText: 'Book Your Consultation',
                viewIndex: index,
            });
        }
    }

    getCertificationTitles = () => {
        if (this.state.provider) {
            let certifications = [];
            for (let certificationId in this.state.provider.certifications) {
                if (certificationId) {
                    certifications.push(this.state.provider.certifications[certificationId].title);
                }
            }
            // console.log(certifications);
            // console.log(`%c${JSON.stringify(certifications)}`,'color: deeppink');
            return certifications;
            // TODO: later we can make a func that grabs suffix if it is needed
        }
    }

    render(){
        // console.log('the width in ED', this.state.width)

        // let filteredServices = [];
        // if (this.props.experts) { 
        //         filteredServices = this.props.experts.filter(expert => {
        //             let expertServiceMatch = false;
        //                 expert.id.forEach(expertService => {
        //                     if (expertServiceValues && expertServiceValues.indexOf(expertService) > -1) {
        //                         expertServiceMatch = true;
        //                     }
        //                 })
        //             return expertServiceMatch;
        //         }
        //     );
        // }
        // const expert = this.getExpert();
        const dateToday = this.getDateToday();
        const { provider, company } = this.state;
        let providerFullName = '';
        if (provider) {
            providerFullName = `${provider.name && provider.name.first} ${provider.name && provider.name.last}`;
        }
        // console.log(`%c${JSON.stringify(provider)} ${JSON.stringify(company)} ${JSON.stringify(service)}`,'color: greenyellow');
        
        const providerCertifications = this.getCertificationTitles();

        return (
            <div style={constants.layout.container}>
                { provider && company &&
                    <div>
                        <VideoModal
                            isOpen={this.state.showModal}
                            onClose={this.handleCloseVideoModal}
                        >
                            <StretchVideo
                                show={this.state.showModal}
                                handleCloseVideo={this.handleCloseVideoModal}
                                source={`//player.vimeo.com/video/${provider.vimeoId}?autoplay=true`}
                                width={640}
                                height={480}
                            />
                        </VideoModal>

                        <Hero
                            id="expertHero"
                            // style={this.state.calendarFlexStyle}
                            backgroundImageURL={provider.coverPhotoURL}
                            mainTitleText={provider.expertise}
                            subTitleText={providerFullName}
                            // butonIconName="play-circle"
                            // buttonText={this.state.mainHeroButtonText}
                            avatarImageURL={provider.profilePhotoURL}
                            avatarLogoURL={company.logoURL}
                            height={this.state.heroHeight}
                            orientation={this.state.heroOrientation}
                            // buttonIconSize={20}
                            buttonAction={() => this.handleChangeViewIndex(1)}
                        />
                        <SwipeableViews
                            index={this.state.viewIndex}
                            onChangeIndex={this.handleChangeViewIndex}
                        >
                            {
                                this.state.viewIndex === 0 &&
                                <div>
                                    <div>
                                        <FluidSection>
                                            <Content
                                                mainTitleText={providerFullName}
                                                mainTitleTextAlt={provider.designation}
                                            />
                                        </FluidSection>
            
                                        <FluidSection style={{ marginBottom: 0, marginTop: (provider.vimeoId) ? 0 : -40 }} id="expertBio">
                                            <Content 
                                                style={{ marginBottom: 40, marginRight: 40 }} 
                                                subTitleText={"Bio"} 
                                                bodyText={`${provider.biography}\n\nWorks at ${company.name}`}
                                            />
                                            <List 
                                                faIconZ2={'check'}
                                                faIcon={'certificate'}
                                                iconSize={45}
                                                style={{ marginBottom: 40 }}
                                                data={providerCertifications}
                                                titleText="Certifications"
                                            />
                                        </FluidSection>
                                    </div>
                                    
                                    {(provider.vimeoId) &&
                                            <Hero
                                                id="expertTitle"
                                                buttonBackgroundColor={constants.color.primary}
                                                buttonIconSize={60}
                                                height={400}
                                                buttonAction={()=>this.handleOpenVideoModal()}
                                                backgroundImageURL={provider.vimeoThumbnailURL}
                                                buttonIconName="play"
                                                playButton
                                                center
                                            />
                                        }

                                    <FluidSection>
                                        <Content
                                            subTitleText={`Services provided by ${providerFullName}`}
                                            style={{ marginBottom: 0, marginRight: 40, maxWidth: 500, }} >
                        
                                        </Content>
                                    </FluidSection>
                                        
                                        <FluidSection style={{ marginBottom: 10 }} sectionMinWidth={300} sectionMaxWidth={590}>
                                            { this.props.services &&
                                                this.getProviderServices(provider, company, providerFullName)
                                            }
                                            
                                        </FluidSection>
            
                                    {/* <Hero
                                        id="expertCTA"
                                        height={300}
                                        backgroundImageURL={expert.backgroundImageURL}
                                        mainTitleText="Book Your Live Consultation Today"
                                        buttonText="Book Your Consultation"
                                        buttonBackgroundColor={constants.color.secondary}
                                        buttonAction={() => this.handleChangeViewIndex(1)}
                                    />*/}
                                </div>
                            }
                            {
                                this.state.viewIndex === 1 &&
                                <div>
                                    
                                    <FluidSection
                                        style={{ marginTop: 40, marginBottom: -20 }}
                                    >
                                        <Content style={{ marginmarginBottom: 40, marginRight: 40 }} mainTitleText={`Booking Calendar`} bodyText={` Click on an available timeslot to book a consultation. Use the 'Next' and 'Previous' buttons to see more available booking times.`}/>
                                    </FluidSection>
                                    
                                    <FluidSection
                                        style={{ marginTop: -170 }}
                                    >
                                        <FlatButton
                                            style={{ marginLeft: 0, marginTop: -50, marginBottom: -50 }}
                                            label="BACK TO BIOGRAPHY"
                                            primary={true}
                                            onClick={() => this.handleChangeViewIndex(0)}
                                            disableTouchRipple={true}
                                            disableFocusRipple={true}
                                            icon={<ArrowLeft />}
                                        />
                                    </FluidSection>

                                    <Calendar></Calendar>
                                </div>
                            }
                        </SwipeableViews>
                    
                    </div>
                }

            </div>
        );
    };
    };

    const mapStateToProps = ({provider, service, company}) => {
        return {
            providers: provider.providers,
            services: service.services,
            serviceCategories: service.categories,
            serviceModules: service.modules,
            companies: company.providerCompanies
        };
    }

export const ExpertDetail = connect(mapStateToProps, actions)(ExpertDetailPage)



// WEBPACK FOOTER //
// ./src/js/containers/ExpertDetail/ExpertDetail.jsx